export default "__VITE_ASSET__8bc3ecf1__"